import { Expose } from "@nts/std/serialization";
import { BaseIdentity } from "./base-identity";
import { IdentityTypeNameDecorator } from "./decorators/identity-type-name.decorator";

@IdentityTypeNameDecorator('DynamicExternalIdentity')
export class DynamicExternalIdentity extends BaseIdentity {

}
